import { Component, ViewEncapsulation, ViewChild, ElementRef } from "@angular/core";
import { Frame, language, date } from "curvy";
import { jobs_management_translations } from "./jobs.trans";
import { TaskRoutes } from "@task-utils/routes";
import { Task } from "@task-utils/types";


function lerp(a: number, b: number, amt: number) {
   if (amt < 0) amt = 0;
   if (amt > 1) amt = 1;
   return a + (b - a)*amt;
}

@Component({
   selector: 'task-temp-staff-calendar',
   template: `
      <div class="calendar-toolbar flex-row">
         <!--label class="input filled" title="Pregled">
            <select [(ngModel)]="view_size">
               <option [ngValue]="3 * day_ms">
                  3 dana
               </option>

               <option [ngValue]="5 * day_ms">
                  5 dana
               </option>

               <option [ngValue]="7 * day_ms">
                  7 dana
               </option>
            </select>
         </label-->

         <button (click)="prev_week()">
            <i icon="chevron_left"></i>
         </button>

         <button (click)="next_week()">
            <i icon="chevron_right"></i>
         </button>

         <span class="large">
            {{ months[monday.getMonth()] }}

            @if (monday.getFullYear() != get_date(7).getFullYear()) {
               {{ monday.getFullYear() }}
            }

            @if (monday.getMonth() != get_date(7).getMonth()) {
               - {{ months[get_date(7).getMonth()] }}
               {{ get_date(7).getFullYear() }}

            } @else {
               {{ monday.getFullYear() }}
            }
         </span>
      </div>

      <div class="calendar-scroller">
         <div class="calendar-view">
            <div class="calendar-cell calendar-header"></div>
            <div class="calendar-cell"></div> <!-- 0 -->
            @for (hour of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23]; track hour) {
               <div class="calendar-cell">
                  <div class="calendar-hour">
                     {{hour}}
                  </div>
               </div>
            }

            @for (day of [1,2,3,4,5,6,7]; track day) {
               <div class="calendar-cell calendar-header">
                  <span>{{ weekdays[day % 7].slice(0, 3) }}</span>
                  <span class="large">{{ get_date(day).getDate() }}</span>
               </div>

               @for (hour of [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23]; track hour) {
                  <div class="calendar-cell">
                     @for (plan of plans ; track plan.temp_staff_plan_id) {
                        @if (is_plan_cell(plan, day, hour)) {
                           <div
                              class="calendar-event"
                              [style.--off]="get_plan_offset(plan)"
                              [style.--size]="get_plan_size(plan)"
                           >
                              <div>{{ plan.planned_start_time | datefmt : 'time' : false }} - {{ plan.planned_end_time | datefmt : 'time' : false }}</div>
                              <div style="font-weight: bold">{{ plan.title }}</div>
                              <div>{{ plan.first_name }} {{ plan.last_name }}</div>
                           </div>
                        }
                     }
                  </div>
               }
            }
         </div>
      </div>
   `,
   encapsulation: ViewEncapsulation.None,
   styles: [`
      task-temp-staff-calendar {
         display: flex;
         flex-flow: column nowrap;

         .large {
            font-weight: normal;
            font-size: 150%;
         }

         .calendar-toolbar {
            background: rgb(var(--background-light));
            padding: .25em .5em;
         }

         .calendar-scroller {
            overflow: auto;
            flex: 1;
         }

         .calendar-view {
            background: rgb(var(--background-dark));
            min-height: 100%;
            display: grid;
            grid-template-rows: auto repeat(24, minmax(2em, 1fr));
            grid-template-columns: auto repeat(7, 1fr);
            grid-auto-flow: column;
         }

         .calendar-cell {
            position: relative;
            border-right: 1px solid rgb(var(--background-text), 0.2);
            border-bottom: 1px solid rgb(var(--background-text), 0.2);

            &.calendar-header {
               position: sticky;
               top: 0;
               background: rgb(var(--background-dark));
               z-index: 2;

               display: flex;
               flex-flow: column nowrap;

               font-weight: bold;
               text-align: center;
               border-bottom: 1px solid rgb(var(--background-text), 0.4);
               padding: .5em;
            }

            /* First column */
            &:nth-child(-n+25) {
               position: relative;
               padding-left: .5em;
               padding-right: .75em;
               padding-bottom: 1em;
               padding-top: 0;
               border: none;

               .calendar-hour {
                  transform: translateY(-50%);
                  text-align: right;
               }

               &::after {
                  content: "";
                  width: .5em;
                  height: 1px;
                  position: absolute;
                  right: 0;
                  top: -1px;
                  background: rgb(var(--background-text), 0.4);
               }
            }

            /* Second column */
            &:nth-child(-n+50):nth-child(n+26) {
               border-left: 1px solid rgb(var(--background-text), 0.4);
            }

            /* Bottom row */
            &:nth-child(25n) {
               border-bottom: none;
            }

            /* Last column */
            &:nth-child(n+176) {
               border-right: none;
            }

            .calendar-event {
               position: absolute;
               box-sizing: border-box;
               z-index: 1;
               left: .25em;
               right: .25em;
               top: calc(var(--off) + .25em);
               height: var(--size);
               background: rgb(var(--primary));
               color: rgb(var(--primary-text));
               padding: .5em;
               border-radius: .5em;
            }
         }
      }
   `],
})

export class TempStaffCalendarComponent {
   monday = new Date();
   weekdays = language.get_weekdays();
   months = language.get_months();

   plans: Array<Task.TempStaffPlan> = [];

   constructor() {
      Frame.set({
         title: "NAVROUTE.JOBS_CALENDAR",
         visible: true,
         layout: "middle",
         size: "full"
      });

      this.monday.setDate(this.monday.getDate() - this.monday.getDay() + 1);
      this.load_week();
   }

   async load_week() {
      let res = await TaskRoutes.temp_staff_requests.api_temp_staff_plans_search({
         attributes: ["-d:planned_start_time", "+d:planned_end_time"],
         search: [
            date.start_of_day(this.monday, false).toISOString(),
            date.end_of_day(this.get_date(7), false).toISOString()
         ]
      });
      this.plans = res.data;
   }

   get_date(offset: number) {
      let d = new Date(this.monday);
      d.setDate(d.getDate() + offset - 1);
      return d;
   }

   next_week() {
      this.monday.setDate(this.monday.getDate()+7);
      this.load_week();
   }

   prev_week() {
      this.monday.setDate(this.monday.getDate()-7);
      this.load_week();
   }

   is_plan_cell(plan: Task.TempStaffPlan, day: number, hour: number) {
      let d = new Date(plan.planned_start_time);
      if (d.getDay() != day%7) return false;
      if (d.getHours() != hour) return false;
      return true;
   }

   get_plan_offset(plan: Task.TempStaffPlan) {
      let d = new Date(plan.planned_start_time);
      let perc = d.getMinutes() / 60;
      return (perc * 100) + "%";
   }

   get_plan_size(plan: Task.TempStaffPlan) {
      let s = new Date(plan.planned_start_time).getHours();
      let e = new Date(plan.planned_end_time).getHours();
      return ((e - s) * 100) + "%";
   }
}
